/* Use Dawn's own drawer focus/scroll handling when an S01 anchor is selected. */
document.addEventListener('click', (event) => {
  const continueShopping = event.target.closest('.s01-theme .s01-continue-shopping');
  if (continueShopping) continueShopping.closest('cart-drawer')?.close();
  const link = event.target.closest('.s01-theme #menu-drawer a[href*="#"]');
  if (!link) return;
  const drawer = link.closest('header-drawer');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event);
  }
});

/* Apply Nova's currency choice through Shopify Markets so prices and checkout agree. */
(() => {
  const renderedCurrency = document.currentScript?.dataset.currency;
  if (!renderedCurrency) return;

  const countries = { HKD: 'HK', USD: 'US' };
  const selectionKey = 's01:nova-markets';
  let localizationTimer;
  let lastSelectedCurrency;

  const syncCurrency = () => {
    const selectedCurrency = document.querySelector('.ba-chosen')?.textContent.trim();
    if (!/^[A-Z]{3}$/.test(selectedCurrency) || selectedCurrency === lastSelectedCurrency) return;
    clearTimeout(localizationTimer);

    if (!countries[selectedCurrency]) {
      const fallback = document.querySelector(`.currMovers[rel="${renderedCurrency}"]`);
      if (fallback) {
        lastSelectedCurrency = selectedCurrency;
        fallback.click();
      }
      return;
    }
    lastSelectedCurrency = selectedCurrency;

    try {
      if (selectedCurrency === renderedCurrency) {
        sessionStorage.removeItem(selectionKey);
        return;
      }

      const selection = `${location.pathname}:${selectedCurrency}`;
      if (sessionStorage.getItem(selectionKey) === selection) return;

      localizationTimer = setTimeout(() => {
        if (document.querySelector('.ba-chosen')?.textContent.trim() !== selectedCurrency) return;
        const nativeForm = document.querySelector('localization-form form');
        if (!nativeForm) return;

        const form = document.createElement('form');
        form.method = nativeForm.method;
        form.action = nativeForm.action;
        form.hidden = true;
        nativeForm.querySelectorAll('input[type="hidden"]').forEach((input) => form.append(input.cloneNode()));

        const setInput = (name, value) => {
          let input = form.querySelector(`input[name="${name}"]`);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            form.append(input);
          }
          input.value = value;
        };
        setInput('country_code', countries[selectedCurrency]);
        setInput('return_to', `${location.pathname}${location.search}`);

        try {
          sessionStorage.setItem(selectionKey, selection);
        } catch {
          return;
        }
        document.body.append(form);
        form.submit();
      }, 150);
    } catch {
      // Skip automatic navigation if storage is unavailable, avoiding redirect loops.
    }
  };

  new MutationObserver(syncCurrency).observe(document.body, { childList: true, subtree: true, characterData: true });
  syncCurrency();
})();
